"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
exports.dateString = reselect_1.createSelector(moduleState, function (state) { return state.dateString; });
exports.isMenuOpen = reselect_1.createSelector(moduleState, function (state) { return state.isMenuOpen; });
exports.isDisabledRCU = reselect_1.createSelector(moduleState, function (state) { return state.isDisabledRCU; });
exports.isOnScreenGuideVisible = reselect_1.createSelector(moduleState, function (state) { return state.isOnScreenGuideVisible; });
exports.longPressModeId = reselect_1.createSelector(moduleState, function (state) { return state.longPressModeId; });
exports.isKeyBoardOpen = reselect_1.createSelector(moduleState, function (state) { return state.isKeyBoardOpen; });
exports.isIPFailover = reselect_1.createSelector(moduleState, function (state) { return state.isIPFailover; });
//# sourceMappingURL=selectors.js.map